import "./i18n";
import React from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import { ignore } from "core/utils/console"


import {
  composeProviders,
  SharedData
} from "contexts";

import { Routes } from "routes";


export const WrappedApp = composeProviders(
  SharedData
)(App);

function App() {
  ignore.infoLogs();
  ignore.warnLogs();
  const win: any = window;
  !!!win["lang"] && (win["lang"] = "en")
  const { i18n } = useTranslation();
  const isRTL = i18n.dir(win["lang"] as string) === "rtl";

  console.log(win["lang"])

  document.body.setAttribute("dir", isRTL ? "rtl" : "ltr");

  return (
    <Router>
      <Routes />
    </Router>
  );
}
